import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { FlowAccordionSummaryExpandWrapper } from './AccordionSummaryExpandWrapper';
import { ChevronDownIcon } from '@/src/components/icon/stroke/ChevronDownIcon';

export const flowAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  defaultProps: {
    // prevent focusing AccordionSummary with tab, we focus IconButton inside
    tabIndex: -1,
    // changed to div to prevent Button in Button invalid html
    component: 'div',
    // removed unwanted a11y properties that are part of IconButton in wrapper
    role: undefined,
    ['aria-expanded']: undefined,
    // change to Flow icon
    expandIcon: <ChevronDownIcon />,
    // extend wrapper with IconButton
    slots: {
      expandIconWrapper: FlowAccordionSummaryExpandWrapper,
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.subheadline,
      // expanding/collapsing icon may cause overflow while transform rotation (45° angle)
      overflow: 'hidden',
      // allow selecting text
      userSelect: 'text',
      // proportions
      padding: '12px 0',
      // focused state
      '&.Mui-focusVisible': {
        backgroundColor: 'transparent',
      },
      // hover effect
      transition: 'color 0.3s ease-out',
      // no need to use interactive style as actual toggle is happening on the IconButton
      '&:hover': {
        // recolor text
        color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os300 : theme.palette.onSurface.os700,
        // hover over IconButton
        '& .MuiAccordion-IconButton': {
          backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.transparent.tertiary : theme.palette.transparent.secondary,
        },
      },
      // disabled state
      '&.Mui-disabled': {
        opacity: '1',
        '&, & .MuiAccordionSummary-expandIconWrapper': {
          color: theme.palette.disabled.tertiary,
        },
      },
    }),
  },
};
